import { AppColors } from "@/styles/colors";
import { Flex, Text, Button } from "@chakra-ui/react";

type DecisionRadioVariant = "accept" | "reject";

interface Props {
  label: string;
  value: string;
  checked: boolean;
  disabled?: boolean;
  variant: DecisionRadioVariant;
  onChange: (value: string) => void;
  width?: string;
  borderColor?: string;
  onDisabledClick?: () => void;
}

export const DecisionRadioCard = ({
  label,
  value,
  checked,
  disabled,
  variant,
  onChange,
  width = "104px",
  borderColor = AppColors.WHITE_BORDER_1,
  onDisabledClick,
}: Props) => {
  const activeColor =
    variant === "accept" ? AppColors.LIGHT_GREEN : AppColors.RED_ICON_ALT;
  const inactiveColor = AppColors.BLACK_TEXT_SECONDARY;

  return (
    <Button
      width={width}
      paddingX="20px"
      paddingY="10px"
      borderRadius="6px"
      border={`2px solid ${borderColor}`}
      position="relative"
      backgroundColor="transparent"
      cursor={disabled ? "not-allowed" : "pointer"}
      opacity={disabled ? 0.6 : 1}

      alignItems="center"
      onClick={() => {
        if (disabled) {
          onDisabledClick?.();
          return;
        }
        onChange(value);
      }}
      aria-pressed={checked}
      aria-disabled={disabled}
    >
      <Flex >
        <Flex
          width="14px"
          height="14px"
          borderRadius="999px"
          border={`2px solid ${checked ? activeColor : inactiveColor}`}
          alignItems="center"
          justifyContent="center"
        >
          {checked && (
            <Flex
              width="6px"
              height="6px"
              borderRadius="999px"
              backgroundColor={activeColor}
            />
          )}
        </Flex>
      </Flex>

      <Text
        fontWeight={600}
        fontSize="12px"
        color={AppColors.GRAY_TEXT}
      >
        {label}
      </Text>

      <Flex />
    </Button>
  );
};
